import React from 'react';
import globalconfig from '../../../common/config';
import { modalConfigs } from '../config/modalConfig';

/**
 * A menu that is displayed when the user hovers over a Raven unit in the limited_raven table.
 * The menu displays the buttons for the more detailed Raven info pages, and a link to a full detail Raven page.
 */
export default class HoverMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ravenStages: globalconfig.ravenStages ? globalconfig.ravenStages : [],
            ravenStage: props.ravenStage
        };
        
        this.modals = modalConfigs;
    }

    renderModalIcon(modalInfo)
    {

        return (
            <div key={modalInfo.url} className="tombstone modal-icon d-inline-block" style={this.props.hide ? {display: 'none'} : {display: 'block'}} >
                <button className='modalbtn' onClick={() => this.props.openModal(this.props.unit, modalInfo)}>
                    {modalInfo.icon && <img src={modalInfo.icon} alt={modalInfo.title} />}
                </button>
                <div className="tooltip-large">
                    <span>
                        {modalInfo.title}
                    </span>
                </div>

            </div>
        );
    }


    render() {
        let modalsIcons = null;
        if (globalconfig.features.ravens.vendorDetailsPreferred) {
            modalsIcons = this.modals.map( (elem) => {
                if (elem.tier && elem.tier === 1)  return this.renderModalIcon(elem); 
                return null;
            });
        } else 
            modalsIcons = this.modals.map( (elem) => { return this.renderModalIcon(elem); });

        return (
            <div className="hover-menu">
                { modalsIcons }
            </div>
        );
    }
}